export const init_state = {
  api_key: null,
  apps: [],
  app_is_loading: false,
  app_size: [],
  components: {},
  connection: {
    app_id: null,
    connected: false
  },
  error: null,
  is_dark: true,
  log_messages: [],
  notification: {
    text: 'Welcome Back!',
    level: null
  },
  req_errors: {},
  req_state: {},
  saved_app_controls: {},
  saved_app_layout: {},
  saved_app_settings: {},
  user: null
}

export default {
  ...init_state
}
